/**
 * Accessible tabs (WAI-ARIA tab pattern) used by collection-tabs and any
 * element with role="tablist" inside a <collection-tabs> or <theme-tabs>.
 */
class ThemeTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (this.tabs.length < 2) return;
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
    document.addEventListener('shopify:block:select', (event) => {
      const index = this.tabs.findIndex((tab) => tab === event.target || tab.contains(event.target));
      if (index > -1) this.activate(index);
    });
  }

  activate(index, focus = false) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
      if (panel) {
        panel.hidden = !selected;
        if (selected) panel.dispatchEvent(new CustomEvent('fivl:content', { bubbles: true }));
      }
    });
    if (focus) this.tabs[index].focus();
    this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }

  onKeydown(event, index) {
    const keys = { ArrowRight: 1, ArrowLeft: -1, Home: -index, End: this.tabs.length - 1 - index };
    if (!(event.key in keys)) return;
    event.preventDefault();
    const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
    this.activate(next, true);
  }
}
if (!customElements.get('collection-tabs')) customElements.define('collection-tabs', ThemeTabs);
if (!customElements.get('theme-tabs')) customElements.define('theme-tabs', class extends ThemeTabs {});
